export const DefaultFilterTable = {
  isChildComponentVisited: true,
  page: 0,
  rowsPerPage: 10,
  orders: {},
};
